import { isCypressTestMode } from "common-fe";

// #1293 — the #1289 renew ladder's signinSilent() call had no Cypress/test-
// mode gate at all, unlike automaticSilentRenew/monitorSession (#1202,
// CogntioAuthProvider). Even when a spec fully stubs the discovery/token
// endpoints a signinSilent() exchange needs, ATTEMPTING the exchange is
// itself a real network request at the Cognito authority — exactly what the
// #1202 afterEach guard (cypress/support/e2e.js) exists to catch. A spec that
// sets up no auth intercepts of its own (e.g. judge-signature-gate.cy.js) hit
// this whenever its API mocking incidentally produced a 401/403.
//
// Suppressed here via the SAME shared signal (common-fe's isCypressTestMode)
// CogntioAuthProvider already uses, rather than a second ad-hoc
// `window.Cypress` check — the two can never drift apart.
//
// offline-sync.cy.js's "Auth-failure ladder" tests deliberately want the REAL
// signinSilent() call fired (that is the behavior under test) and fully stub
// the discovery/token endpoints it hits, so they opt back in by setting
// `window.__CYPRESS_RENEW_LADDER_OVERRIDE__ = true` before visiting.
export function shouldSuppressAuthRenew() {
  if (!isCypressTestMode()) return false;
  return !(
    typeof window !== "undefined" && window.__CYPRESS_RENEW_LADDER_OVERRIDE__
  );
}
